/** Identity colour of each app area (home cards, profile module chips), from the theme tokens. */
export type ModuleAccent =
  'analytics' | 'ml' | 'tools' | 'traceability' | 'labelize' | 'recommender';

/** Icon / text colour. */
export const MODULE_TEXT: Record<ModuleAccent, string> = {
  analytics: 'text-module-analytics',
  ml: 'text-module-ml',
  tools: 'text-module-tools',
  traceability: 'text-module-traceability',
  labelize: 'text-module-labelize',
  recommender: 'text-module-recommender',
};

/** Tinted chip (border + background + text), for `Badge` `className`. */
export const MODULE_CHIP: Record<ModuleAccent, string> = {
  analytics: 'border-module-analytics/30 bg-module-analytics/10 text-module-analytics',
  ml: 'border-module-ml/30 bg-module-ml/10 text-module-ml',
  tools: 'border-module-tools/30 bg-module-tools/10 text-module-tools',
  traceability: 'border-module-traceability/30 bg-module-traceability/10 text-module-traceability',
  labelize: 'border-module-labelize/30 bg-module-labelize/10 text-module-labelize',
  recommender: 'border-module-recommender/30 bg-module-recommender/10 text-module-recommender',
};
